import React, { useState, useEffect } from 'react';

import { getAllFood, createCombo, createFieldCombo, AddFoodForField } from '../api/food'

const CreateCombo = ({ token }) => {

    
    const [comboFields, setComboFields] = useState([{text: '', id:1, foods: []}])
    const [selectedFood, setSelectedFood] = useState()
    const [allFood, setAllFood] = useState({})
    const [allFoodName, setAllFoodName] = useState(null)
    const [Loading, setLoading] = useState(true)
    const [minHours, setMinHours] = useState(null)
    const [nameCombo, setNameCombo] = useState(null)




    const loadAllCombo = async () => {
        try {
            const allFood = await getAllFood(token)
            setAllFood(allFood)
            let foodName = {}
            for (let food of allFood){
                foodName[food.id] = food.name
            }
            setAllFoodName(foodName)
            setLoading(false)
        } catch (err) {
            console.error(err);
        }
        };
    
    useEffect(() => {

        loadAllCombo();
    }, [token]);


    function addField(){
        setComboFields([...comboFields, {text: '', id: comboFields.length+1, foods: [] }])
        console.log(minHours)
    }

    function changeField(text, id){
        setComboFields(comboFields.map(field => 
            field.id == id ? {...field, text:text}: field
        ))
    }

    function removeField(){
        setComboFields(comboFields.slice(0, -1));
    }

    function selectFood(foodId, fieldId){
        setSelectedFood({foodId: Number(foodId), fieldId:fieldId})
    }


    function addFoodInField(){
        setComboFields(comboFields.map(field => 
        {
            if (field.id != selectedFood.fieldId) return field;

            const foodAlready = field.foods.some(food => 
                food.foodId == selectedFood.foodId
            )
            if (foodAlready){
                return field
            }
            return {
                ...field,
                foods: [...field.foods, selectedFood]
            }
        }
        ))
    }

    function removeFoodInField(){
        setComboFields(comboFields.map(field => 
            field.id == selectedFood.fieldId ? {...field, foods: field.foods.slice(0, -1)}: field
        ))
    }

    async function CreateNewCombo(event){
        const newCombo = await createCombo(token, nameCombo, minHours)
        // console.log(newCombo)
        const comboId = newCombo.id
        // console.log(minHours, nameCombo)
        // console.log(213)
        console.log(comboFields, 8888)
        for (let field of comboFields){
            // console.log(field)
            const fieldCombo = await createFieldCombo(token, comboId, field.text)
            
            // 
            
            for (let food of field.foods){
                const foodField = await AddFoodForField(token, fieldCombo.id, food.foodId)
                // console.log(foodField)
            }
        }
        // console.log(comboFields)
    }

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="name" style={{marginTop: "5%"}}>
                    <div className="input-group">
                        <span className="input-group-text">Введите название нового комбо</span>
                        <input type="text" name="" id="" className='form-control' value={nameCombo} onChange={(e) => setNameCombo(e.target.value)}/>
                        <span className="input-group-text">Введите минимальное кол-во часов для выбора комбо</span>
                        <input type="number" name="" id="" className='form-control' value={minHours} onChange={(e) => setMinHours(Number(e.target.value))}/>
                    </div>
                </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="fields" style={{marginTop: "5%"}}>
                <ul className="list-group">
                    {comboFields.map(field => (
                    <li className="list-group-item">
                        <div className="input-group">
                            <span className="input-group-text">Название поля</span>
                            <input type="text" className="form-control" onChange={(e) => changeField(e.target.value, field.id)}/>
                        </div>
                        
                        <div className="food">
                            <div className="input-group">
                            
                            <span className="input-group-text">Добавление еды для поля</span>
                            <select className='form-select' name="" id="" onChange={(e) => selectFood(e.target.value, field.id)}>
                                <option value={0}>Не выбрано</option>
                                { (!Loading) && (allFood.map(food =>
                                    (<option value={food.id}>{food.name}</option>)
                                    )
                                )
                                }
                            </select>
                            </div>
                           <ul className="list-group">
                            {field.foods.map(food => (
                                <li className="list-group-item">{allFoodName[food.foodId]}</li>
                            ))}
                            </ul>
                            <div className="btns" style={{marginTop: "5%"}}>
                                <button  className="btn" onClick={addFoodInField}>Добавить еду в поле</button>
                                <button className="btn" onClick={removeFoodInField}>Убрать еду из поля</button>
                            </div>
                            
                            <hr />
                        </div>
                    </li>
                ))}
                    
                </ul>
                
                <div className="btns" style={{marginTop: "5%"}}>
                    <button className="btn" onClick={addField}>Добавить поле</button>
                    <button className="btn" onClick={removeField}>Удалить поле</button>
                </div>
                
            </div>
                </div>
            </div>
            <hr />
            <div className="btn" onClick={CreateNewCombo}>Создать</div>
            
            
        </div>
    );
};

export default CreateCombo;
